import { ImportWizard } from "@/components/onboarding/components";
import { TrackedEvent, trackEvent } from "@/domains/metrics";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { useEffect, useRef } from "react";

interface ImportCtaOverlayProps {}

export const ImportCtaOverlay = observer<ImportCtaOverlayProps>(() => {
  const { store } = useAppStore();
  const isOpen = store.platformInfo.onboardingInfo.shouldShowImportCta;
  useTrackView(isOpen);

  return (
    <ImportWizard
      isOpen={isOpen}
      onClose={() => {
        store.platformInfo.dismissImportCta();
      }}
      onSkip={() => {
        store.platformInfo.dismissImportCta();
      }}
    />
  );
});

const useTrackView = (isOpen: boolean) => {
  const didTrack = useRef(false);
  useEffect(() => {
    if (didTrack.current || !isOpen) return;
    trackEvent(TrackedEvent.ImportWizardView);
    didTrack.current = true;
  }, [isOpen]);
};
